import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import "../../../assets/saas/molecules/_car-title-availability.scss";
import { container } from "tsyringe";
import { useState, useEffect } from "react";
import { findTranslation } from "../../../../infrastructure/i18n/findTranslation";
import { getUrlLocale } from "../../../../utils/getUrlLocale";
const ModelInformation = ({ model, category, categories }) => {
    var _a, _b;
    const [categoryConfig, setCategoryConfig] = useState(null);
    const _GetCategoryConfig = container.resolve("iUseCaseCategoryConfig");
    const { t } = useTranslation();
    const [categoryObject, setCategoryObject] = useState(null);
    useEffect(() => {
        const getCategoryConfig = async () => {
            const response = await _GetCategoryConfig.getCategoryConfig();
            setCategoryConfig(response);
            setCategoryObject(response.find((cat) => cat.category === categories));
        };
        getCategoryConfig().then(() => {
        });
    }, []);
    // WI #8320 — Previously this expression was doubly broken:
    //   1. The first `.find()` predicate compared a string to a boolean
    //      (`x === y.includes(...)`), so it always returned `false`.
    //   2. The fallback `.find()` used `.includes()` and would match the
    //      wrong language when `i18next.language` was contaminated by the
    //      country selector (e.g. "es-DE" matches both "ES" and "DE").
    // Both issues are fixed by `findTranslation` keyed off the URL locale.
    const categoryTranslation = (_b = (_a = findTranslation(categoryObject === null || categoryObject === void 0 ? void 0 : categoryObject.translations, getUrlLocale("lower"))) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : categoryObject === null || categoryObject === void 0 ? void 0 : categoryObject.name;
    return (_jsxs("div", { className: "title-availability", children: [_jsx("h2", { className: "title-availability__text", children: model === null || model === void 0 ? void 0 : model.toUpperCase() }), _jsx("span", { className: "title-availability__subtitle", children: _jsxs("strong", { children: [t("o"), " ", categoryTranslation, " ", t("similar"), "  "] }) })] }));
};
export default ModelInformation;
